package com.vamvisions.main.core.presentation.appshell

import com.vamvisions.main.core.domain.preferences.Language

sealed interface AppShellAction {
    data object ToggleColorScheme : AppShellAction
    data class SetLanguage(val language: Language) : AppShellAction
}
